import { render } from "./ListarTransferenciaMrp.vue?vue&type=template&id=5cd1fc3f&scoped=true"
import script from "./ListarTransferenciaMrp.vue?vue&type=script&lang=js"
export * from "./ListarTransferenciaMrp.vue?vue&type=script&lang=js"

import "./ListarTransferenciaMrp.vue?vue&type=style&index=0&id=5cd1fc3f&scoped=true&lang=css"
import "./ListarTransferenciaMrp.vue?vue&type=style&index=1&id=5cd1fc3f&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cd1fc3f"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QDate from 'quasar/src/components/date/QDate.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QField from 'quasar/src/components/field/QField.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QBtn,QSelect,QInput,QIcon,QPopupProxy,QDate,QTable,QImg,QTd,QPagination,QDialog,QCard,QCardSection,QCardActions,QField});qInstall(script, 'directives', {ClosePopup});
